/**
 * 页面来源枚举
 */
export enum OpenType {
  TAB = 'tab', //发现页
  SITE = 'site', //站内分享
  OUT = 'out', //站外分享
  AD = 'ad', //广告位
  PUSH = 'push', //推送
  MSG = 'msg', //站内信
  BANNER = 'banner', //横幅广告
  LIVE = 'live', //直播间
  BEANPAY = 'beanPay', //软妹豆购买页
  BEANPAYINNER = 'beanPayInner', //站内打开的软妹豆购买页
  FEED = 'feed', // feed
}

/**
 * 埋点事件类型
 */
export enum ActivityType {
  OPEN = 'open',//打开页面
  EXPOSURE_ELEMENT = 'exposure_element',//曝光元素
  CLICK_ELEMENT = 'click_element',//点击元素
  EXPOSURE = 'exposure',//曝光
  HEAD = 'head', //头像点击
  HEARTBEAT = 'heartbeat', //心跳（如播放时长）
  PLAY_COMPLETE = 'play_complete', //播放完成
}

/**
 * 会员权益枚举
 */
export enum VipPrivilege {
  ANONYMOUS_BROWSING = 'anonymous_browsing', // 无痕浏览
  WHO_HAS_VISITED_ME = 'who_has_visited_me', // 谁看过我
  WHO_LIKE_ME = 'whoLikeMe', // 谁喜欢我
  ROAM_WORLD = 'roam_world', // 世界漫游
  MSG_SNEAK_UP = 'msg_sneak_up', // 悄悄已读
  PRETENDING_LOVERS = 'pretendingLovers', // 假装情侣
  ADS = 'ads', // 免广告
  ONLINE_DISTANCE_HIDING = 'online_distance_hiding', // 隐藏在线/距离
  NEARBY_INVISIBLE = 'nearby_invisible', // 附近自由隐身
  WINK_OR_FANS_HIDING = 'wink_or_fans_hiding', // 隐藏挤眼/粉丝
  SECRETLY_FOLLOW = 'secretly_follow', // 偷偷关注
  UNLOCK_MATCH_USER_PAGE = 'unlock_match_user_page', // 解锁速配主页
  NEARBY_FILTER = 'nearby_filter', // 附近的人高级筛选
  FLASH_CHAT = 'flash_chat',//心动闪聊匹配特权
  /**
   * 速配反悔 iOS那边用的是recall
   */
  MATCH_REVERT = 'match_revert',

  /**
   * 速配优先曝光
   */
  MATCH_PRIVILEDGE = 'match_priviledge',

  /**
   * 取消关注提醒
   */
  UN_FOLLOW = 'un_follow',

  /**
   * 置顶日志
   */
  STICK = 'stick',

  /**
   * 更快修改昵称
   */
  CHANGE_NICKNAME = 'change_nickname',

  /**
   * 点亮会员身份
   */
  MEMBERSHIP_EXPOSURE = 'membership_exposure',

  /**
   * 添加更多蜜友
   */
  CIRCLE_BFF = 'circle_bff',

  // -- 二级选项 --

  /**
   * 隐藏在线状态
   */
  ONLINE_HIDING = 'onlineHiding',

  /**
   * 隐藏距离
   */
  DISTANCE_HIDING = 'distanceHiding',

  /**
   * 附近的人隐身
   */
  NEARBY_HIDING = 'nearby_hiding',

  /**
   * 附近日志隐身
   */
  NEARBY_MOMENT_HIDING = 'nearby_moment_hiding',

  /**
   * 隐藏粉丝
   */
  FANS_HIDING = 'fansHiding',

  /**
   * 隐藏挤眼
   */
  WINK_HIDING = 'winkHiding',
}